// Cylindo Viewer Script Loading
// Load Cylindo viewer and thumbnail bar scripts dynamically
// See: https://pdp.cylindo.com/

if (typeof window !== 'undefined') {
    // IM-009: Register the <cylindo-viewer> to the product page head
    // Add preconnect for better performance
    const existingPreconnect = document.querySelector('link[href*="content.cylindo.com"]')
    if (!existingPreconnect) {
        const preconnect = document.createElement('link')
        preconnect.rel = 'preconnect'
        preconnect.href = 'https://content.cylindo.com'
        preconnect.crossOrigin = 'anonymous'
        document.head.appendChild(preconnect)
        console.log('[Cylindo] Preconnect added')
    }

    // Load Cylindo Viewer module
    const existingViewerScript = document.querySelector('script[src*="viewer-cdn.cylindo.com/v1/index.mjs"]')
    if (!existingViewerScript) {
        const viewerScript = document.createElement('script')
        viewerScript.type = 'module'
        viewerScript.src = 'https://viewer-cdn.cylindo.com/v1/index.mjs'
        viewerScript.async = true
        document.head.appendChild(viewerScript)

        viewerScript.onload = () => {
            console.log('[Cylindo] Viewer script loaded')
        }

        viewerScript.onerror = () => {
            console.error('[Cylindo] Failed to load viewer script')
        }
    }

    // IM-010: Inject the <cylindo-thumbnail-bar> script
    const existingBarScript = document.querySelector('script[src*="viewer-cdn.cylindo.com/v1/bar.mjs"]')
    if (!existingBarScript) {
        const barScript = document.createElement('script')
        barScript.type = 'module'
        barScript.src = 'https://viewer-cdn.cylindo.com/v1/bar.mjs'
        barScript.async = true
        document.head.appendChild(barScript)

        barScript.onload = () => {
            console.log('[Cylindo] Thumbnail bar script loaded')
        }

        barScript.onerror = () => {
            console.error('[Cylindo] Failed to load thumbnail bar script')
        }
    }
}

